import { css } from "styled-components";
import { ThemeProp } from "styles/theme";

export const colorPropagationStyles = css`
  body {
    color: ${({ theme }: ThemeProp) => theme.textInLight};
    background: ${({ theme }: ThemeProp) => theme.emptyBackground};
  }

  .color-propagation
    *:not(
      .prevent-color-propagation,
      .prevent-color-propagation *:not(.color-propagation),
      .oculus-input,
      .oculus-input *
    ) {
    color: inherit;
  }
`;
